import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "card-form__main" }
const _hoisted_3 = { class: "card-form__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "card-form" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "text-h5" }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "card-form__logo",
            src: require('@/assets/svg/logo.svg'),
            alt: ""
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }),
      _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "card-form__hr-solid" }, null, -1)),
      _createVNode(_component_v_card_text, { style: {"width":"25rem"} }, {
        default: _withCtx(() => [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-form__name" }, "Sign Up", -1)),
          _createVNode(_component_v_alert, {
            "model-value": !!_ctx.errorText.length,
            closable: "",
            type: "error",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorText = []))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.errorText[0]), 1)
            ]),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(_component_v_alert, {
            "model-value": !!_ctx.infoText,
            closable: "",
            type: "info",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.infoText = ''))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.infoText), 1)
            ]),
            _: 1
          }, 8, ["model-value"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_form, {
              ref: "form",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.sendForm()), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                  label: "Your email",
                  color: "primary",
                  placeholder: "Enter your email",
                  rules: [_ctx.rules.required, _ctx.rules.isEmail],
                  variant: "outlined"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_btn, {
                  type: "submit",
                  class: "card-form__send-button",
                  color: "primary",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" Email Me an Invite Link ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createTextVNode(" Already have an account? ")),
            _createElementVNode("a", {
              href: "/",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('change', 'login')), ["prevent"]))
            }, "Sign In here")
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}